import usersService from '@/services/usersService'
import Vue from 'vue'
const state = {
  advancedInvitedSearch: {},
  advancedSearch: {
    selectedExtradata: [],
    extradata: {},
    filterResponsible: [],
    journeyArray: [],
    roles: [],
    socialNetworks: [],
    usersLikings: {
      and: [],
      or: []
    },
    spotifyGenres: {
      and: [],
      or: []
    },
    spotifyArtists: {
      and: [],
      or: []
    },
    spotifyTracks: {
      and: [],
      or: []
    },
    verified: undefined,
    isImported: undefined
  },
  historicalActions: [],
  invitedUsers: [],
  users: [],
  loadingUser: false,
  loadingInvitedUsers: false,
  loadingUsers: true,
  paginationInvitedUsers: {},
  paginationUsers: {},
  totalInvitedUsers: 0,
  totalUsers: 0,
  selectedUser: {},
  search: '',
  searchInvited: '',
  userDocuments: [],
  totalUserDocuments: 0,
  loadingEmailVerify: false,
  loadingFileExportUser: false
}

const mutations = {
  'ADD_CUSTOM_EXTRA_DATA' (state, value) {
    const extraData = {
      field: value.name,
      value: '',
      access: value.access,
      extraDataCustomId: value.id,
      type: value.type,
      options: value.options
    }
    state.selectedUser.extraData.push(extraData)
  },
  'CLEAR_EXTRADATA' (state) {
    state.advancedSearch.extradata = {}
  },
  'CLEAR_ADVANCED_SEARCH' (state) {
    state.advancedSearch = {
      selectedExtradata: [],
      extradata: {},
      filterResponsible: [],
      journeyArray: [],
      roles: [],
      socialNetworks: [],
      usersLikings: {
        and: [],
        or: []
      },
      spotifyGenres: {
        and: [],
        or: []
      },
      spotifyArtists: {
        and: [],
        or: []
      },
      spotifyTracks: {
        and: [],
        or: []
      },
      verified: undefined,
      isImported: undefined
    }
  },
  'INIT_EXTRADATA' (state) {
    state.advancedSearch.selectedExtradata = []
    state.advancedSearch.extradata = {}
  },
  'SET_HISTORICAL_ACTIONS' (state, historicalActions) {
    state.historicalActions = historicalActions
  },
  'SET_TOTAL_USERS' (state, totalUsers) {
    state.totalUsers = totalUsers
  },
  'SET_TOTAL_INVITED_USERS' (state, totalUsers) {
    state.totalInvitedUsers = totalUsers
  },
  'SET_USERS' (state, users) {
    state.users = users
  },
  'SET_USER_ROW' (state, userInfo) {
    const { rowIndex, user } = userInfo
    Vue.set(state.users, rowIndex, user)
  },
  'SET_INVITED_USERS' (state, users) {
    state.invitedUsers = users
  },
  'SET_SEARCH_USERS' (state, search) {
    state.search = search
  },
  'SET_SEARCH_INVITED_USERS' (state, search) {
    state.searchInvited = search
  },
  'SET_LOADING_INVITED_USERS' (state, status) {
    state.loadingInvitedUsers = status
  },
  'SET_LOADING_USER' (state, status) {
    state.loadingUser = status
  },
  'SET_LOADING_USERS' (state, status) {
    state.loadingUsers = status
  },
  'SET_PAGINATION_USERS' (state, pagination) {
    state.paginationUsers = pagination
  },
  'SET_PAGINATION_INVITED_USERS' (state, pagination) {
    state.paginationInvitedUsers = pagination
  },
  'SET_SELECTED_USER' (state, user) {
    state.selectedUser = user
  },
  'SET_USER_DOCUMENTS' (state, userDocuments) {
    state.userDocuments = userDocuments
  },
  'SET_USER_TOTAL_DOCUMENTS' (state, totalUserDocuments) {
    state.totalUserDocuments = totalUserDocuments
  },
  'SET_SELECTED_USER_EMAIL_VALIDATE' (state, result) {
    state.selectedUser = { ...state.selectedUser, emailValidationResult: result }
  },
  'SET_LOADING_EXPORT_USER' (state, value) {
    state.loadingFileExportUser = value
  }
}

const actions = {
  addUserToList (vuexContext, { userId, listId }) {
    return new Promise((resolve, reject) => {
      usersService.addUserToList(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        userId,
        listId
      ).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async changeOrAddExtraDataInBlock (vuexContext, { companyId, appId, data }) {
    const app = appId || vuexContext.getters.appUuid
    const company = companyId || vuexContext.getters.companyUuid
    await usersService.changeOrAddExtraDataInBlock(vuexContext.getters.token, company, app, data)
  },
  async changeUsersJourneyInBlock (vuexContext, { companyId, appId, data }) {
    const app = appId || vuexContext.getters.appUuid
    const company = companyId || vuexContext.getters.companyUuid
    await usersService.changeUsersJourneyInBlock(vuexContext.getters.token, company, app, data)
  },
  async createNewTaskInBlock (vuexContext, { companyId, appId, data }) {
    const app = appId || vuexContext.getters.appUuid
    const company = companyId || vuexContext.getters.companyUuid
    await usersService.createNewTaskInBlock(vuexContext.getters.token, company, app, data)
  },
  async changeUserResponsibleInBlock (vuexContext, { companyId, appId, data }) {
    const app = appId || vuexContext.getters.appUuid
    const company = companyId || vuexContext.getters.companyUuid
    await usersService.changeUserResponsibleInBlock(vuexContext.getters.token, company, app, data)
  },
  createUser (vuexContext, data) {
    return new Promise((resolve, reject) => {
      usersService.createUser(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        data)
        .then(user => {
          resolve(user)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteUser (vuexContext, { companyId, appId, userId }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      usersService.deleteUser(vuexContext.getters.token, company, app, userId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async deleteUserDocument (vuexContext, { companyId, appId, userId, documentId }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    await usersService.deleteUserDocument(
      vuexContext.getters.token,
      company,
      app,
      userId,
      documentId
    )
    return true
  },
  generateKeys (vuexContext, { genPublicKey, genPrivateKey }) {
    return new Promise((resolve, reject) => {
      usersService.generateKeys(vuexContext.getters.token, genPublicKey, genPrivateKey).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  generateOneTimePassword (vuexContext, { sendMail, sendPhone }) {
    return new Promise((resolve, reject) => {
      usersService.generateOneTimePassword(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.getters.userUuid,
        { sendMail, sendPhone })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAdminUserInfo (vuexContext) {
    return new Promise((resolve, reject) => {
      usersService.getAdminUserInfo(vuexContext.getters.token).then(response => {
        if (response.user) {
          resolve(response.user)
        } else {
          reject(new Error('Persona no encontrada'))
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getExtradataLabels (vuexContext) {
    return new Promise((resolve, reject) => {
      usersService.getExtradataLabels(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid
      ).then(response => {
        resolve(response.fields)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getHistoricalOfUserActions (vuexContext, userId) {
    return new Promise((resolve, reject) => {
      usersService.getHistoricalOfUserActions(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        userId)
        .then(response => {
          vuexContext.commit('SET_HISTORICAL_ACTIONS', response.hist)
          resolve(true)
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getInvitedUsers (vuexContext) {
    vuexContext.commit('SET_LOADING_INVITED_USERS', true)
    usersService.getInvitedUsers(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      vuexContext.state.paginationInvitedUsers,
      vuexContext.state.searchInvited,
      vuexContext.state.advancedInvitedSearch)
      .then(response => {
        vuexContext.commit('SET_TOTAL_INVITED_USERS', response.invitations.count)
        vuexContext.commit('SET_INVITED_USERS', response.invitations.rows)
        vuexContext.commit('SET_LOADING_INVITED_USERS', false)
      })
      .catch(() => {
        vuexContext.commit('SET_INVITED_USERS', [])
        vuexContext.commit('SET_LOADING_INVITED_USERS', false)
      })
  },
  getPublicKey (vuexContext) {
    return new Promise((resolve, reject) => {
      vuexContext.commit('SET_LOADING_USER', true)
      usersService.getPublicKey(vuexContext.getters.token).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async getUser (vuexContext, { companyId, appId, userId }) {
    vuexContext.commit('SET_LOADING_USER', true)
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid

    const response = await usersService.getUser(vuexContext.getters.token, company, app, userId)

    if (response.user) {
      vuexContext.commit('SET_SELECTED_USER', response.user)
      vuexContext.commit('SET_LOADING_USER', false)
      return true
    } else {
      vuexContext.commit('SET_SELECTED_USER', {})
      vuexContext.commit('SET_LOADING_USER', false)
      return true
    }
  },
  async getUserLikings (vuexContext, userId) {
    const company = vuexContext.getters.companyUuid
    const app = vuexContext.getters.appUuid
    const response = await usersService.getUserLikings(vuexContext.getters.token, company, app, userId)
    return response.likings
  },
  getUserSpotifyTops (vuexContext, userId) {
    return new Promise((resolve, reject) => {
      try {
        const company = vuexContext.getters.companyUuid
        const app = vuexContext.getters.appUuid
        usersService.getUserSpotifyTops(vuexContext.getters.token, company, app, userId)
          .then(response => {
            if (response) resolve(response.spotifyInsights)
          })
          .catch(error => {
            reject(error)
          })
      } catch (error) {
        reject(error)
      }
    })
  },
  getUserInfo (vuexContext, { companyId, appId, userId }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      usersService.getUser(vuexContext.getters.token, company, app, userId).then(response => {
        if (response.user) {
          resolve(response.user)
        } else {
          reject(new Error('Persona no encontrada'))
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUsers (vuexContext, data) {
    vuexContext.commit('SET_LOADING_USERS', true)

    usersService.getUsers(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      vuexContext.state.paginationUsers,
      vuexContext.state.search,
      vuexContext.state.advancedSearch,
      data)
      .then(response => {
        vuexContext.commit('SET_TOTAL_USERS', response.users.count)
        vuexContext.commit('SET_USERS', response.users.rows)
        vuexContext.commit('SET_LOADING_USERS', false)
      })
      .catch(() => {
        vuexContext.commit('SET_USERS', [])
        vuexContext.commit('SET_TOTAL_USERS', 0)
        vuexContext.commit('SET_LOADING_USERS', false)
      })
  },
  async getUserDocuments (vuexContext, { companyId, appId, userId }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    try {
      const response = await usersService.getUserDocuments(
        vuexContext.getters.token,
        company,
        app,
        userId
      )
      vuexContext.commit('SET_USER_TOTAL_DOCUMENTS', response.documents.count)
      vuexContext.commit('SET_USER_DOCUMENTS', response.documents.rows)
    } catch (e) {
      vuexContext.commit('SET_USER_DOCUMENTS', [])
      throw e
    }
  },
  async updateAdminUserInfo (vuexContext, data) {
    await usersService.updateAdminUserInfo(vuexContext.getters.token, data)
  },
  updateUser (vuexContext, data) {
    return usersService.updateUser(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      data
    )
  },
  async updateUserDocument (vuexContext, { companyId, appId, data }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    await usersService.updateUserDocument(
      vuexContext.getters.token,
      company,
      app,
      data
    )
    return true
  },
  async uploadUserDocument (vuexContext, { companyId, appId, userId, data }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    await usersService.uploadUserDocument(
      vuexContext.getters.token,
      company,
      app,
      userId,
      data
    )
    return true
  },
  updateUserExtradata (vuexContext, { userId, extradata }) {
    return new Promise((resolve, reject) => {
      usersService.updateUserExtradata(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        userId,
        { extradata }
      ).then((response) => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async sendSmsToUser (vuexContext, data) {
    return await usersService.sendSmsToUser(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      data
    )
  },
  sendUsersSms (vuexContext, message) {
    const filters = {
      ...vuexContext.state.advancedSearch,
      search: vuexContext.state.search
    }
    return new Promise((resolve, reject) => {
      usersService.sendSms(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        message,
        filters)
        .then(response => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  sendInvitedUsersSms (vuexContext, message) {
    const filters = {
      ...vuexContext.state.advancedInvitedSearch,
      search: vuexContext.state.searchInvited
    }
    return new Promise((resolve, reject) => {
      usersService.sendSmsInvitedUsers(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        message,
        filters)
        .then(response => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  uploadInvitationsFileAndSendSms (vuexContext, data) {
    return new Promise((resolve, reject) => {
      usersService.uploadInvitationsFileAndSendSms(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        data.message,
        data.file)
        .then(response => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  async verifyEmail (vuexContext, { companyId, appId, email }) {
    let flag = false
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    const response = await usersService.verifyEmail(vuexContext.getters.token, company, app, email)
    const validationEmail = response.emailVerificationResult.validationResult

    if (validationEmail !== 'key not valid') {
      flag = true
    }
    return { flag, validationEmail }
  },
  async exportFileUser (vuexContext, { companyId, appId, data }) {
    try {
      vuexContext.commit('SET_LOADING_EXPORT_USER', true)
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      await usersService.exportFileUsers(vuexContext.getters.token, company, app, data)
      vuexContext.commit('SET_LOADING_EXPORT_USER', false)
    } catch (e) {
      vuexContext.commit('SET_LOADING_EXPORT_USER', false)
      throw e
    }
  }

}

const getters = {
  isSearching (state) {
    return Boolean(
      (state.search && state.search.trim()) ||
      state.advancedSearch.roles.length > 0 ||
      state.advancedSearch.journeyArray.length > 0 ||
      state.advancedSearch.filterResponsible.length > 0 ||
      state.advancedSearch.socialNetworks.length > 0 ||
      state.advancedSearch.usersLikings.or.length > 0 ||
      state.advancedSearch.usersLikings.and.length > 0 ||
      state.advancedSearch.spotifyGenres.or.length > 0 ||
      state.advancedSearch.spotifyGenres.and.length > 0 ||
      state.advancedSearch.spotifyArtists.or.length > 0 ||
      state.advancedSearch.spotifyArtists.and.length > 0 ||
      state.advancedSearch.spotifyTracks.or.length > 0 ||
      state.advancedSearch.spotifyTracks.and.length > 0 ||
      (
        Object.keys(state.advancedSearch.extradata).length > 0 &&
        Object.values(state.advancedSearch.extradata).find(value => value)
      ) ||
      state.advancedSearch.verified ||
      state.advancedSearch.isImported
    )
  },
  userExtraDatas (state, getters, rootState) {
    const { extraData } = state.selectedUser
    const ed = [...extraData]
    if (!state.selectedUser || !Array.isArray(ed)) return []
    const appExtradata = rootState.apps.appCustomExtradatas
    const length = appExtradata.length

    for (let i = 0; i < length; i++) {
      const result = ed.find(item => {
        return item.field === appExtradata[i].name
      })
      if (result) {
        result.extraDataCustomId = appExtradata[i].id
        result.tags = appExtradata[i].tags
        result.type = appExtradata[i].type
        result.options = appExtradata[i].options
      } else {
        ed.push({
          field: appExtradata[i].name,
          value: '',
          access: appExtradata[i].access,
          extraDataCustomId: appExtradata[i].id,
          tags: appExtradata[i].tags,
          type: appExtradata[i].type,
          options: appExtradata[i].options
        })
      }
    }
    return ed
  },
  totalUsers (state) {
    return state.totalUsers
  },
  userDocuments (state) {
    if (!state.userDocuments || !Array.isArray(state.userDocuments)) return []
    return state.userDocuments
  },
  userUuid (state) {
    return state.selectedUser.UUID
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
